function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 倒计时
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds
      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_hour1').html(hours.toString().slice(0, 1))
      $('.sp_hour2').html(hours.toString().slice(1, 2))
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_minute1').html(minutes.toString().slice(0, 1))
      $('.sp_minute2').html(minutes.toString().slice(1, 2))
      $('.sp_second').html(seconds)
      $('.sp_second1').html(seconds.toString().slice(0, 1))
      $('.sp_second2').html(seconds.toString().slice(1, 2))
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    $('.sp-part1-btns').click(function () {
      $('.mask-123').css('display', 'flex')
      $('.mask-123 .size-pop').css('display', 'flex')
    })
    $('.close-pop').click(function () {
      $('.mask-123').hide()
    })
    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop()
      var targetSection = $('.sp-header-bottom')
      var targetHeight =
        $('.sp-header-bottom').height() + $('.time-part').height()
      if (scrollTop >= targetHeight) {
        targetSection.addClass('sp-fixed-top')
      } else if (scrollTop < targetHeight) {
        targetSection.removeClass('sp-fixed-top')
      }
    })
    new Swiper('.mySwiper', {
      loop: true,
      autoplay: {
        delay: 4000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    var mySwiper2 = new Swiper('.mySwiper2', {
      loop: true,
      autoplay: {
        delay: 4000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      on: {
        slideChange: function () {
          $('.sp-part1-box2>ul li')
            .eq(this.realIndex)
            .addClass('active')
            .siblings()
            .removeClass('active')
        },
      },
    })
    $('.sp-part1-box2>ul li').click(function () {
      var index = $(this).index()
      mySwiper2.slideToLoop(index)
      $(this).addClass('active').siblings().removeClass('active')
    })
    new Swiper('.mySwiper3', {
      loop: true,
      autoplay: {
        delay: 4000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    new Swiper('.mySwiper4', {
      loop: true,
      autoplay: {
        delay: 4000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    var mySwiper = new Swiper('.mySwiper5', {
      loop: true,
      autoplay: {
        delay: 4000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    $('.sp-btn-lf').click(function () {
      mySwiper.slidePrev()
    })
    $('.sp-btn-rl').click(function () {
      mySwiper.slideNext()
    })
    new Swiper('.mySwiper6', {
      loop: true,
      autoplay: {
        delay: 4000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      on: {
        slideChange: function () {
          $('.sp-progressbar .sp-circle')
            .eq(this.realIndex)
            .addClass('active')
            .siblings()
            .removeClass('active')
          var width = '180px'
          if (this.realIndex == 0) {
            width = '180px'
          } else if (this.realIndex == 1) {
            width = '50%'
          } else {
            width = '100%'
          }
          $('.sp-progressbar i').css('width', width)
        },
      },
    })

    new Swiper('#swiper', {
      centeredSlides: true,
      loop: true,
      watchSlidesProgress: true,
      spaceBetween: 0,
      slidesPerView: 'auto',
      freeMode: true,
      speed: 30500, //匀速时间
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    new Swiper('#swiper2', {
      centeredSlides: true,
      loop: true,
      watchSlidesProgress: true,
      spaceBetween: 30,
      slidesPerView: 'auto',
      freeMode: true,
      speed: 5500, //匀速时间
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    new Swiper('#swiper3', {
      centeredSlides: true,
      loop: true,
      watchSlidesProgress: true,
      spaceBetween: -20,
      slidesPerView: 5,
      freeMode: true,
      speed: 1500, //匀速时间
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    new Swiper(".sp-swiper-btn", {
        autoplay: true,
        autoplay: {
        disableOnInteraction: false,
        },

        loop: true,
    });
    // 展开
    $('.sp-pro-shopping>ul li').click(function () {
      if ($(this).hasClass('sp-makeup') == true) {
        $(this).removeClass('sp-makeup')
      } else {
        $(this).addClass('sp-makeup')
      }
    })
    // 动画
    $('#goods-image_header_1').show()
    $('#goods-image_header_2').hide()
    let header_flag = false
    setInterval(() => {
      header_flag = !header_flag
      if (header_flag) {
        $('#goods-image_header_1').hide()
        $('#goods-image_header_2').show()
      } else {
        $('#goods-image_header_1').show()
        $('#goods-image_header_2').hide()
      }
    }, 1000)
    // 文字标题动画
    const graduallyList = document.getElementsByClassName('gradually')
    for (let gradually of graduallyList) {
      const spans = gradually.querySelectorAll('span'),
        paragraph = gradually.querySelector('.sp-sub-title'),
        observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                spans.forEach((span, index) => {
                  ;(span.style.animation = 'swift-up-fade 0.5s ease forwards'),
                    (span.style.animationDelay = `${index * 0.15}s`)
                  const i = span.querySelector('i')
                  i &&
                    ((i.style.animation = 'swift-up-fade 0.5s ease forwards'),
                    (i.style.animationDelay = `${index * 0.15}s`))
                })
                const totalDelay = spans.length * 0.15 + 0.3
                paragraph &&
                  ((paragraph.style.animation =
                    'swift-up-fade 0.5s ease forwards'),
                  (paragraph.style.animationDelay = `${totalDelay}s`)),
                  observer.unobserve(gradually)
              }
            })
          },
          { threshold: 0.3 }
        )
      observer.observe(gradually)
    }
    const fadeWraper = document.getElementsByClassName('sp-fade-box')
    for (let fadebox of fadeWraper) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach(
          (entry) => {
            if (entry.isIntersecting) {
              fadebox.querySelectorAll('.sp-ani').forEach((div, index) => {
                ;(div.style.animation = 'sp-fade-in 1s ease forwards'),
                  (div.style.animationDelay = `${index * 1}s`)
              })
              observer.unobserve(fadebox)
            }
          },
          { threshold: 0.3 }
        )
      })
      observer.observe(fadebox)
    }
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop =
          targetElement.offsetTop - $('.sp-header-bottom').height()
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }

  $('.sp-btn-style').click(function () {
    let num = 1
    const id = $(this).attr('data-id')
    window.location.href = '/cart/' + id + ':' + num
  })
}

mainRender()
